import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _find from 'lodash/find';
import _get from 'lodash/get';
import { LocalizedMessage } from 'intl/LocalizedComponents';
// Core component
import Tooltip from 'components/core/Tooltip';
// Models
import mCustomer from 'models/cpm/customer';
// Custom
import { cpmCustomerDataShape, cpmParkingCategoryDataShape, cpmOneparkBookingDataShape } from 'constants/PropTypesShapes';
import TableCellInformationItem from 'components/items/TableCellInformationItem';
import ParkingCategoryIcon from 'cpmCarparks/assets/parkingCategories/ParkingCategoryIcon';
import ParkingCategoryTitle from 'cpmCarparks/assets/parkingCategories/ParkingCategoryTitle';
import { OneparkLogoImg } from 'components/img/AssetImg';

const CustomerTableCellItem = ({ customer, parkingCategory }) => {
  let customIcon = null;
  let customLabel = null;
  let customValue = null;

  if (customer.lastname) {
    customValue = mCustomer.fullName(customer);
  }

  if (customer.bookingId) {
    customIcon = OneparkLogoImg(null, 24);
    customLabel = <LocalizedMessage id="field.oneparkBooking" />;
    customValue = mCustomer.bookingCustomerFullName(customer);
  }

  const tooltipContent = (customer && customer.email) ? customer.email : null;

  return (
    <Tooltip content={tooltipContent}>
      <TableCellInformationItem
        customIcon={parkingCategory ? <ParkingCategoryIcon parkingCategory={parkingCategory} /> : customIcon}
        label={parkingCategory ? <ParkingCategoryTitle parkingCategory={parkingCategory} /> : customLabel}
        value={customValue}
      />
    </Tooltip>
  );
};

CustomerTableCellItem.propTypes = {
  customer: PropTypes.oneOfType([
    cpmCustomerDataShape,
    cpmOneparkBookingDataShape,
  ]).isRequired,
  parkingCategory: cpmParkingCategoryDataShape,
};

CustomerTableCellItem.defaultProps = {
  parkingCategory: null,
};

const mapStateToProps = (state, ownProps) => ({
  parkingCategory: _find(state.cpmCarparkParkingCategory.list.elements, ['id', _get(ownProps, 'parkingCategory.id', _get(ownProps, 'customer.parkingCategory.id', null))]),
});

module.exports = connect(
  mapStateToProps,
)(CustomerTableCellItem);



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/customers/CustomerTableCellItem.js